<template>
<div class="mx-auto">
  <v-tooltip right v-if="nextLink">
    <template v-slot:activator="{on, attrs}">
      <v-btn 
          v-on="on"
          v-bind="attrs" 
          pill outlined 
          color="#121212" 
          x-small 
          class="btn-learn mx-auto rounded-pill" 
          @click="nextPage"
        >
        <v-icon color="grey">mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    {{ $t('viewMore.clickToExplore') }}
  </v-tooltip>
  <div v-else>
        <v-icon color="grey">mdi-dots-horizontal</v-icon>
  </div>
  </div>
</template>
<script>
export default {
  name: "ViewMore",
  props:['link', 'nextLink'],
  methods:{
    nextPage()
    {
      if(this.nextLink)
    {
        this.$router.push(this.link)
    }
    }
  }
};
</script>

<style>
.btn-learn{
  max-width: 32px;
}
.btn-learn:hover {
  background-color: #9c9c9c66;
  transition:all .3s ease-out;
}
</style>